import { Link, useLocation } from "react-router-dom";
import { Lock, FileDown } from "lucide-react";
import { useAuth } from "../auth";
import { useLang } from "../lang";

export default function DatasheetAccess({ url }) {
  const { user } = useAuth();
  const { lang } = useLang();
  const it = lang === "it";
  const { pathname } = useLocation();

  if (user && url) {
    return (
      <a href={url} target="_blank" rel="noopener noreferrer" className="a-link inline-flex items-center gap-2 text-[14px]" data-testid="pdp-datasheet-download">
        <FileDown size={15} strokeWidth={1.75} />
        {it ? "Scarica la scheda tecnica" : "Download datasheet"}
      </a>
    );
  }

  return (
    <p className="inline-block text-[13px] leading-relaxed text-[#6e6e73] text-center" data-testid="pdp-datasheet-locked">
      <span className="whitespace-nowrap">
        <Lock size={13} strokeWidth={1.75} className="inline-block align-[-2px] mr-1.5 text-[#1D3F94]" />
        {it ? "Schede tecniche riservate ai professionisti." : "Datasheets reserved for professionals."}
      </span>{" "}
      <Link to={`/login?next=${encodeURIComponent(pathname)}`} className="text-[#1D3F94] hover:underline whitespace-nowrap" data-testid="pdp-datasheet-login">
        {it ? "Accedi all'area riservata" : "Sign in to the reserved area"} <span className="chev">›</span>
      </Link>
    </p>
  );
}
